export default __webpack_public_path__ + "static/media/bottomBun.b68d4a52.png";